import { useTranslation } from 'react-i18next';

import { CreateHolidayGroupModal } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateHolidaySubGroup } from 'src/hooks/holiday-manager/create-holiday-sub-group.hook';
import { useGetAllHolidayLocationsByCompany } from 'src/hooks/holiday-manager/get-holiday-locations-by-company.hook';

const CreateHolidayGroup = ({
  initialHolidayLocation,
  onClose,
}: {
  initialHolidayLocation?: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation(['common', 'settings']);

  const currentCompanyId = useGetCurrentCompanyId();
  const { holidayLocations } = useGetAllHolidayLocationsByCompany(currentCompanyId);

  const createHolidaySubGroup = useCreateHolidaySubGroup({ onSuccess: onClose });

  const onFinish = (values: any) => {
    const { calendarFile, ...subGroupValues } = values;
    createHolidaySubGroup({
      variables: {
        payload: { ...subGroupValues, icsFile: calendarFile.fileList[0].originFileObj },
      },
      onCompleted: onClose,
    });
  };

  return (
    <CreateHolidayGroupModal
      onClose={onClose}
      t={t}
      initialHolidayLocation={initialHolidayLocation}
      onFinish={onFinish}
      holidayLocations={holidayLocations}
    />
  );
};

export default CreateHolidayGroup;
